import { EOrderType } from '@aqx-core/common/api/order/model/types';
import { EOrderTableColumn } from '@aqx-core/common/api/user-account-setting';

export const ORDERS_MAX_SIZE = 30;

export const BUY_ORDER_TYPES = [
  EOrderType.BUY,
  EOrderType.BUY_LIMIT,
  EOrderType.BUY_STOP,
  EOrderType.BUY_STOP_LIMIT,
  EOrderType.BUY_MARKET_TO_LIMIT
];

export const SELL_ORDER_TYPES = [
  EOrderType.SELL,
  EOrderType.SELL_LIMIT,
  EOrderType.SELL_STOP,
  EOrderType.SELL_STOP_LIMIT
];

export enum EAssetsOrderTab {
  OPEN_POSITION = 'OPEN_POSITION',
  PENDING_ORDER = 'PENDING_ORDER',
  ORDER_HISTORY = 'ORDER_HISTORY',
  POSITION_HISTORY = 'POSITION_HISTORY',
  ORDERS_AND_DEALS = 'ORDERS_AND_DEALS',
  ORDER_HISTORY_CENTROID = 'ORDER_HISTORY_CENTROID'
}

export enum EOrderColumn {
  OPEN_TIME = EOrderTableColumn.OPEN_TIME,
  ORDER_ID = EOrderTableColumn.ORDER_ID,
  SYMBOL = EOrderTableColumn.SYMBOL,
  TYPE = EOrderTableColumn.TYPE,
  PROFIT_LOSS = EOrderTableColumn.PROFIT_LOSS,
  VOLUME_SIZE = EOrderTableColumn.VOLUME_SIZE,
  VOLUME = EOrderTableColumn.VOLUME,
  UNITS = EOrderTableColumn.UNITS,
  ENTRY_PRICE = EOrderTableColumn.ENTRY_PRICE,
  CURRENT_PRICE = EOrderTableColumn.CURRENT_PRICE,
  TAKE_PROFIT = EOrderTableColumn.TAKE_PROFIT,
  STOP_LOSS = EOrderTableColumn.STOP_LOSS,
  SWAP = EOrderTableColumn.SWAP,
  COMMISSION = EOrderTableColumn.COMMISSION,
  MARGIN = EOrderTableColumn.MARGIN,
  NOTIONAL = EOrderTableColumn.NOTIONAL
}

export enum EOrderDealHistoriesColumn {
  DEAL_TYPE = EOrderTableColumn.DEAL_TYPE,
  OPEN_TIME = EOrderTableColumn.OPEN_TIME,
  CLOSE_TIME = EOrderTableColumn.CLOSE_TIME,
  ORDER_ID = EOrderTableColumn.ORDER_ID,
  SYMBOL = EOrderTableColumn.SYMBOL,
  TYPE = EOrderTableColumn.TYPE,
  STATE = EOrderTableColumn.STATE,
  VOLUME_SIZE = EOrderTableColumn.VOLUME_SIZE,
  UNITS = EOrderTableColumn.UNITS,
  FILL_POLICY = EOrderTableColumn.FILL_POLICY,
  ENTRY_PRICE = EOrderTableColumn.ENTRY_PRICE,
  TAKE_PROFIT = EOrderTableColumn.TAKE_PROFIT,
  STOP_LOSS = EOrderTableColumn.STOP_LOSS,
  PROFIT_LOSS = EOrderTableColumn.PROFIT_LOSS,
  SWAP = EOrderTableColumn.SWAP,
  COMMISSION = EOrderTableColumn.COMMISSION,
  REMARKS = EOrderTableColumn.REMARKS
}

export enum EOrderHistoriesColumn {
  OPEN_TIME = EOrderTableColumn.OPEN_TIME,
  SYMBOL = EOrderTableColumn.SYMBOL,
  CLOSE_TIME = EOrderTableColumn.CLOSE_TIME,
  ORDER_ID = EOrderTableColumn.ORDER_ID,
  STATUS = EOrderTableColumn.STATUS,
  TYPE = EOrderTableColumn.TYPE,
  PROFIT_LOSS = EOrderTableColumn.PROFIT_LOSS,
  VOLUME_SIZE = EOrderTableColumn.VOLUME_SIZE,
  UNITS = EOrderTableColumn.UNITS,
  ENTRY_PRICE = EOrderTableColumn.ENTRY_PRICE,
  CLOSE_PRICE = EOrderTableColumn.CLOSE_PRICE,
  TAKE_PROFIT = EOrderTableColumn.TAKE_PROFIT,
  STOP_LOSS = EOrderTableColumn.STOP_LOSS,
  SWAP = EOrderTableColumn.SWAP,
  COMMISSION = EOrderTableColumn.COMMISSION,
  REMARKS = EOrderTableColumn.REMARKS,
  TIME_IN_FORCE = EOrderTableColumn.TIME_IN_FORCE,
  AVG_FILLED_PRICE = EOrderTableColumn.AVG_FILLED_PRICE,
  FILLED_VOLUME = EOrderTableColumn.FILLED_VOLUME,
  MARKET_RANGE = EOrderTableColumn.MARKET_RANGE
}

export enum EOrderPendingColumn {
  OPEN_TIME = EOrderTableColumn.OPEN_TIME,
  ORDER_ID = EOrderTableColumn.ORDER_ID,
  SYMBOL = EOrderTableColumn.SYMBOL,
  TYPE = EOrderTableColumn.TYPE,
  VOLUME_SIZE = EOrderTableColumn.VOLUME_SIZE,
  UNITS = EOrderTableColumn.UNITS,
  FILL_POLICY = EOrderTableColumn.FILL_POLICY,
  EXPIRY = EOrderTableColumn.EXPIRY,
  EXPIRY_DATE = EOrderTableColumn.EXPIRY_DATE,
  ENTRY_PRICE = EOrderTableColumn.ENTRY_PRICE,
  PENDING_PRICE = EOrderTableColumn.PENDING_PRICE,
  CURRENT_PRICE = EOrderTableColumn.CURRENT_PRICE,
  TAKE_PROFIT = EOrderTableColumn.TAKE_PROFIT,
  STOP_LOSS = EOrderTableColumn.STOP_LOSS,
  PRICE = EOrderTableColumn.PRICE,
  VOLUME = EOrderTableColumn.VOLUME,
  FILLED_VOLUME = EOrderTableColumn.FILLED_VOLUME,
  MARKET_RANGE = EOrderTableColumn.MARKET_RANGE
}

export const COLUMN_ID_TO_EXPORT_COLUMN_MAP: Record<string, string> = {
  symbol: 'SYMBOL',
  orderId: 'ORDER_ID',
  positionId: 'ORDER_ID', // MT5 uses positionId
  orderType: 'TYPE',
  profit: 'PROFIT_LOSS',
  status: 'STATUS',
  openTime: 'OPEN_TIME',
  closeTime: 'CLOSE_TIME',
  lotSize: 'VOLUME_SIZE',
  units: 'UNITS',

  openPrice: 'ENTRY_PRICE',
  currentPrice: 'CURRENT_PRICE',
  closePrice: 'CLOSE_PRICE',
  priceTrigger: 'PENDING_PRICE',
  price: 'PRICE',
  takeProfit: 'TAKE_PROFIT',
  stopLoss: 'STOP_LOSS',

  // Centroid
  notional: 'NOTIONAL',
  marginRate: 'MARGIN',

  // Other columns
  swap: 'SWAP',
  commission: 'COMMISSION',
  exitMethod: 'REMARKS',

  // Pending order specific
  tradeExpiry: 'EXPIRY',
  expiration: 'EXPIRY_DATE',
  fillPolicy: 'FILL_POLICY',
  filledVolume: 'FILLED_VOLUME',
  marketRange: 'MARKET_RANGE',
  avgFilledPrice: 'AVG_FILLED_PRICE',

  // Orders & Deals specific
  state: 'STATE',
  centroidOrderState: 'STATE',
  comments: 'REMARKS',
  closedTransactionType: 'TYPE',
  orderBalanceType: 'TYPE'
};

export const MIN_MARKET_RANGE_VALUE = 0;
